import { useBreakpoints } from '@vueuse/core';

const MOBILE_MAX_WIDTH = 550;
const TABLET_MAX_WIDTH = 1486;

export function useDeviceDetector() {
  const breakpoints = useBreakpoints({
    mobile: MOBILE_MAX_WIDTH,
    tablet: TABLET_MAX_WIDTH,
  });

  const isMobile = breakpoints.smallerOrEqual('mobile');
  const isTablet = breakpoints.between('mobile', 'tablet');

  return {
    isMobile,
    isTablet,
  };
}
